import { LAST_MONTH } from '@/constant';

function transformTableTag(tableTag, owner) {
  const { type, child } = owner;
  return {
    type,
    child,
    tag: tableTag.name,
  };
}
function transformChild({ type, children }) {
  const {
    name: childName,
    title: childTitle,
    description: chidlDescription,
    chart_tags: chartTags = [],
    table_tags: tableTags = [],
  } = children;
  let transformedTableTag;
  if (tableTags) {
    transformedTableTag = tableTags.map(tableTag =>
      transformTableTag(tableTag, { type, child: childName }),
    );
  }
  if (!chartTags.length) {
    return {
      label: childTitle,
      description: chidlDescription,
      value: {
        type,
        child: childName,
        name: childName,
        tableTags: transformedTableTag,
      },
    };
  }
  if (chartTags.length === 1) {
    const tagName = chartTags[0];
    return {
      label: childTitle,
      description: chidlDescription,
      value: {
        type,
        child: childName,
        tag: tagName.name,
        name: childName,
        tableTags: transformedTableTag,
      },
    };
  }
  const newTags = chartTags.map(tag => ({
    label: tag.title,
    description: tag.description,
    value: {
      type,
      child: childName,
      tag: tag.name,
      name: tag.name,
      tableTags: transformedTableTag,
    },
  }));
  return {
    label: childTitle,
    description: chidlDescription,
    value: {
      name: childName,
    },
    children: newTags,
  };
}

function transformType(data) {
  const types = data.map(({ title, description, name, children = [] }) => {
    const newChild = children.map(child =>
      transformChild({ type: name, children: child }),
    );
    if (newChild.length === 1) return newChild[0];
    return {
      label: title,
      description,
      value: {
        name,
      },
      children: newChild,
    };
  });
  return types;
}

function transformRangeList(data) {
  return data.map(range => ({
    label: range.title,
    value: range.name,
  }));
}

function findTypeValueByName(name, types) {
  for (let i = 0; i < types.length; i += 1) {
    const { value, children } = types[i];
    const { name: typeName } = value;
    if (typeName === name) return value;
    if (children) {
      const result = findTypeValueByName(name, children);
      if (result) return result;
    }
  }
}

function findDefaultType(types, defaults) {
  if (!types) return;
  const isTripleType = defaults && defaults.tag;
  let defaultName;
  if (defaults) {
    defaultName = defaults.tag || defaults.child;
  } else {
    defaultName = 'active_install';
  }
  const value = findTypeValueByName(defaultName, types);
  if (!value) return [];

  const typeValue = findTypeValueByName(value.type, types);
  if (isTripleType) {
    const childValue = findTypeValueByName(value.child, types);
    return [typeValue, childValue, value];
  }
  return [typeValue, value];
}

function findDefaultRange(ranges) {
  for (let i = 0; i < ranges.length; i += 1) {
    const { value } = ranges[i];
    if (value === LAST_MONTH) {
      return value;
    }
  }
}

function setDefaultFilters({ types, ranges, defaults }) {
  const defaultType = findDefaultType(types, defaults);
  const defaultRange = findDefaultRange(ranges);
  if (defaultType && defaultRange) {
    return {
      type: defaultType,
      range: defaultRange,
    };
  }
  return undefined;
}

function transformChartsConfig(types) {
  if (!types) return {};
  let chartsConfig = {};

  for (const type of types) {
    chartsConfig = {
      ...chartsConfig,
      [type.name]: {
        title: type.title,
        description: type.description,
      },
      ...transformChartsConfig(type.children),
      ...transformChartsConfig(type.chart_tags),
    };

    if (type.chart_dimensions) {
      chartsConfig[type.name].yAxis = type.chart_dimensions['y-axis'];
    }
  }

  return chartsConfig;
}

export default function transformFilters({ types, ranges, defaults }) {
  const mappedChartsConfig = transformChartsConfig(types);

  const transformedTypes = transformType(types);
  const transformedRanges = transformRangeList(ranges);
  const defaultFilters = setDefaultFilters({
    types: transformedTypes,
    ranges: transformedRanges,
    defaults,
  });

  return {
    types: transformedTypes,
    ranges: transformedRanges,
    defaults: defaultFilters,
    chartsConfig: mappedChartsConfig,
  };
}
